import $ from 'jquery';
import { order, orderCancel, orderRepeat } from "../queries";

(async function () {
    if ($('.page-personal').length === 0) {
        return;
    }
    const response = await order();
    $('.page-personal-orders__items').html(response.component).removeClass('page-personal-orders__items--loading');
    $('.ui-scroll').each(function () {
        $(this).trigger('init');
    });
})();

$(document).on('click', '.page-personal-order__header', function () {
    $(this).parents('.page-personal-order')
        .toggleClass('page-personal-order--opened')
        .find('.ui-scroll')
        .trigger('update');
});

$(document).on('click', '.js-page-personal-order__repeat', async function () {
    const products = [];

    $(this).parents('.page-personal-order').find('.ui-product-simple').each(function () {
        const id = $(this).attr('data-id');
        const externalId = $(this).attr('data-external-id');
        const quantity = $(this).attr('data-quantity');
        if (id) {
            products.push({ id, quantity, external_id: externalId });
        }
    });

    if (products.length === 0) {
        alert('Товары из данного заказа, отсутствуют в продаже.');
        return;
    }

    const response = await orderRepeat(products);

    if (!response.isSuccess) {
        alert(response.error);
        return;
    }

    window.location = '/basket';
});

$(document).on('click', '.js-page-personal-order__cancel', async function () {
    const id = $(this).parents('.page-personal-order').attr('data-id');

    if (!confirm('Подтвердите отмену заказа')) {
        return;
    }

    $('.page-personal-orders__items').addClass('page-personal-orders__items--loading');

    await orderCancel(id);

    const response = await order();
    $('.page-personal-orders__items').html(response.component).removeClass('page-personal-orders__items--loading');
});

